import { Injectable, Optional, Inject, LOCALE_ID } from "@angular/core";
import { DatePipe } from "@angular/common";

@Injectable()
export class DateService 
{
    //@Inject("datePipe") @Optional() private datePipe : DatePipe,@Inject(LOCALE_ID) private locale: string
    constructor( ){}
    monthsTab = Array("janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre");
    getNewDate()
    {
        return new Date();
    }
    initialiserTab(tab: myColspan[], lengthTab: number) 
    {
        tab = new Array(lengthTab)
        for (var i = 0; i < tab.length; i++) 
        {
        tab[i] = new myColspan();
        }
        return tab;
    } 
    getWeekNumber(uneDate) 
    {
        var d = new Date(uneDate);
        var DoW = d.getDay();
        d.setDate(d.getDate() - (DoW + 6) % 7 + 3); // Nearest Thu
        var ms = d.valueOf(); // GMT
        d.setMonth(0);
        d.setDate(4); // Thu in Week 1
        return Math.round((ms - d.valueOf()) / (7 * 864e5)) + 1;
    }
    dateDiff(date1, date2) 
    {
        //myDate.setDate(myDate.getDate() + 1)
        var i=0;
        var MydateDebu = new Date(date1.getFullYear(),date1.getMonth(),date1.getDate()) ;
        if(date1 == date2)
        return 1;
        else
        do
        {
            i++;
            MydateDebu.setDate(MydateDebu.getDate() + 1);
        }
        while(MydateDebu.getTime()<=date2.getTime())
        return i;
    }
    monthDiff(d2, d1) 
    {
        var months;
        d2 = new Date(d2);
        d1 = new Date(d1);
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        if(months ==0)
        return d2.getMonth() - d1.getMonth();
        else    
        if(months ==12)
        {
        var a=(12-d1.getMonth());
        var b=d2.getMonth();
        return (a+b) ;
        }
        else
        return ((13-d1.getMonth())+d2.getMonth()+1+months) ;
    }
    yearDiff(dateold, datenew) 
    {
        var ynew = datenew.getFullYear();
        var yold = dateold.getFullYear();
        return ynew-yold ;
    }
    getFirstDayOfWeek(dt:Date)
    {
        
        var currentWeekDay = dt.getDay();
        var lessDays = currentWeekDay == 0 ? 6 : currentWeekDay - 1;
        var wkStart = new Date(new Date(dt).setDate(dt.getDate() - lessDays));
        var wkEnd = new Date(new Date(wkStart).setDate(wkStart.getDate() + 6));
        return wkStart
    }
    getListWeek(d1,d2)
    {
        var d = new Date(d1.getFullYear(),d1.getMonth(),d1.getDate());
        var tabWeek= new Array<myColspan>(); 
        var nbrDay = this.dateDiff(d,d2);
        var week = new myColspan();
        week.colSpan = this.getWeekNumber(d);
        week.monthName = d1.getDate()+"/"+ (d1.getMonth()+1)+"/"+ d1.getFullYear();
        for(var i=0;i<nbrDay;i++)
        {        
            var find = tabWeek.find(function(element)
            {
                return element.colSpan == week.colSpan;
            });
            if(find == undefined )
                tabWeek.push(week.newMyColSpan(week.monthName,week.colSpan));
            week.colSpan = this.getWeekNumber(d.setDate(d.getDate()+ 1));
            week.monthName = d.getDate()+"/"+ (d.getMonth()+1)+"/"+ d.getFullYear();
            
        }
        // d= new Date(tabWeek[tabWeek.length-1].monthName);
        // var dd= new Date(d2);
        // if(d.getTime()<dd.getTime())
        // {            
        //     week.colSpan = tabWeek[tabWeek.length-1].colSpan+1;
        //     week.monthName = dd.getDate()+"/"+ (dd.getMonth()+1)+"/"+ dd.getFullYear();
        //     tabWeek.push(week.newMyColSpan(week.monthName,week.colSpan));
        // }
        return tabWeek;
    }
    getListMonth(date_Debut,date_Fin,numberDay) 
    {
        var date = new Date(date_Debut.getFullYear(),date_Debut.getMonth(),date_Debut.getDate());
        var MonthDebut = date_Debut.getMonth();
        var MonthFin = date_Fin.getMonth();
        var selectedMonthsTab = this.initialiserTab(selectedMonthsTab, this.monthDiff(date_Fin , date_Debut)+1 );
        var starDay = date_Debut.getDate()- 1;
        var endDay = date_Fin.getDate();
        var yearDiff = (this.yearDiff(date_Debut,date_Fin)*12);
        
        if (MonthDebut + date_Debut.getFullYear() == MonthFin + date_Fin.getFullYear() ) 
        {
        selectedMonthsTab[0].monthName = this.monthsTab[MonthDebut];
        selectedMonthsTab[0].colSpan = numberDay;
        selectedMonthsTab[0].monthId = MonthDebut;
        selectedMonthsTab[0].year = date_Debut.getFullYear();
        }
        else 
        {
        var i = 0;
        var compt = 0;
        do 
        {        
            if(MonthDebut + i >11)
                compt = 12
            var lastDayOfMonth = (new Date(date_Debut.getFullYear(), MonthDebut + i + 1, 0)).getDate();
            selectedMonthsTab[i].monthName = this.monthsTab[(MonthDebut + i)-compt];
            selectedMonthsTab[i].colSpan = (lastDayOfMonth - starDay) ;
            selectedMonthsTab[i].monthId = (MonthDebut + i)-compt;
            selectedMonthsTab[i].year = date.getFullYear();
            date.setMonth(date.getMonth()+1);
            starDay = 0;
            i++;        
        }
        while (MonthDebut + i < (MonthFin+yearDiff));
        if(MonthDebut + i >11)
            compt = 12
        selectedMonthsTab[i].monthName = this.monthsTab[(MonthDebut + i)-compt];
        selectedMonthsTab[i].colSpan = endDay;
        selectedMonthsTab[i].monthId = ((MonthDebut + i)-compt);
        selectedMonthsTab[i].year = date.getFullYear();
        }
        return selectedMonthsTab;
    }
    getListYear(date_Debut,date_Fin)
    {
        var selectedMonthsTab=[];
        var yearDebut = date_Debut.getFullYear();
        var yearFin = date_Fin.getFullYear();
        if(yearDebut == yearFin)
        {
            selectedMonthsTab.push(yearDebut);
        }
        else 
        {
            var yearDiff = this.yearDiff(date_Debut,date_Fin);            
            for(var i=0;i<yearDiff+1;i++)
            {               
                selectedMonthsTab.push(yearDebut);
                yearDebut++;
            }
        }
        return selectedMonthsTab;
    }
    setFormaTime(time)
    {
      if(time != null)
      {
        time = time.split(":");
        if(time.length>1)
          return time[0]+":"+time[1];
      }
      
      return "";
    }
    setFormaTimeCalendar(time)
    {
        time = this.setFormaTime(time).replace(":",".");
        if(time == "")
            return null
        return Number(time);
    }
    setHtmlselectTime()
    {
        var time : string[]=[""];
        time.pop();
        var d = new Date("1/1/2000 08:00");
        do
        {
            time.push(d.getHours() + ":" + d.getMinutes());
            d.setMinutes(d.getMinutes()+15);
        }
        while (d.getHours()<18);
        time.push("18:0");
        return time;
    }
    setFormatDate(date)
    {
        date = new Date(date);
        var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
        return date.toLocaleDateString("fr-FR", options);         
    }
    setFormatDateServer(date)
    {
        var tab = date.split("-");
        return new Date(tab[0], (tab[1]-1),tab[2]);
    }
    setFormatDateServerStr(date)
    {
        var tab = date.split("-");
        return(tab[2]+"/"+ tab[1]+"/"+ tab[0]);
    }
    setToFormatDateServerStr(date:Date):string
    {
        
        var date2 = this.setFormatDate(date);
        var tab = date2.split("/");
        return tab[2]+"-"+tab[1]+"-"+tab[0];
    }
    setFormatDateRechercheServer(date :Date)
    {
        var date2 = this.setFormatDate(date);
        var tab = date2.split("/");
        return tab[2].toString()+tab[1].toString()+tab[0].toString();
    }
    convertStrToDate(date2)
    {
        var tab = date2.split("/");
        return new Date(tab[2],tab[1]-1,tab[0]) ;
    }
    isSamediOrDimenche(myDate:Date)
    {
        var test = false;
        if (myDate.getDay() == 6 || myDate.getDay() == 0) 
        {
            test = true;
        }
        return test
    }
    getLastDayOfMonth(month: number)
    {
        var lastDayOfMonth;
        var date2 = new Date((new Date().getFullYear()),month,1);
        date2.setDate(date2.getDate()-1);
        lastDayOfMonth = date2.getDate();
        return lastDayOfMonth;
    }
    timeDif(t1, t2) 
    {
        var date1 = new Date("2000-01-01 " + t1);
        var date2 = new Date("2000-01-01 " + t2);
        var heur = ((date2.getTime() - date1.getTime()) / (1000 * 3600));
        return heur;
    }
}

class myColspan 
{
  constructor() { }
  newMyColSpan(monthName, colSpan)
  {
      var my_Colspan = new myColspan();
      my_Colspan.monthName = monthName;
      my_Colspan.colSpan = colSpan;
      return my_Colspan;
  }
  monthName: string;
  colSpan: number;
  monthId:Number;
  year:Number;
}